import { render } from "./RecoverSuccess.vue?vue&type=template&id=673f731e&scoped=true"
import script from "./RecoverSuccess.vue?vue&type=script&lang=js"
export * from "./RecoverSuccess.vue?vue&type=script&lang=js"

import "./RecoverSuccess.vue?vue&type=style&index=0&id=673f731e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673f731e"]])

export default __exports__